import { FeatureFlag, OnboardingWorkflow } from '../../CommonSelectors/CommonArea.types';

interface Params {
  onboardingWorkflow: OnboardingWorkflow | null;
  modulesToHide: string[] | null;
  optOuts: string[] | null;
  featureFlags: FeatureFlag[] | null;
  componentName: string | null;
}

export const updateConsumerAreaGlobalContext = ({
  onboardingWorkflow,
  modulesToHide,
  optOuts,
  featureFlags,
  componentName,
}: Params) => {
  ADV.data.user.ModulesToHide = modulesToHide;
  ADV.data.user.ConsumerAccessWorkflow = onboardingWorkflow;
  ADV.data.user.OptOuts = optOuts;
  ADV.data.user.FeatureFlags = featureFlags;
  ADV.data.user.ComponentName = componentName;
};
